<template>
  <div>
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-row class="mx-2 my-1">
        <!-- 日 -->
        <v-col cols="12" md="8">
          <v-row>
            <v-col cols="6">
              <v-card class="mt-6">
                <v-sheet
                  class="v-sheet--offset mx-auto"
                  color="green"
                  elevation="3"
                  max-width="calc(100% - 32px)"
                >
                  <v-sparkline
                    :labels="labels"
                    :value="ordersCountByHourValue"
                    color="white"
                    line-width="2"
                    padding="16"
                  ></v-sparkline>
                </v-sheet>

                <v-card-text class="mt-n3 pt-0 pb-1">
                  <v-list-item class="px-0">
                    <v-list-item-content
                      class="subheading font-weight-normal grey--text"
                      >{{ $t("Top.orders_wait_deliver_count") }}
                    </v-list-item-content>
                    <v-list-item-content
                      class="
                        d-flex
                        justify-end
                        px-0
                        py-1
                        title
                        font-weight-bols
                        mb-2
                      "
                    >
                      {{ ordersTotal.total_count }}
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
              </v-card>
              <div class="hide">1</div>
              <!-- 周 -->
              <v-card class="mt-6">
                <v-sheet
                  class="v-sheet--offset mx-auto"
                  color="blue"
                  elevation="3"
                  max-width="calc(100% - 32px)"
                >
                  <v-sparkline
                    :labels="week_labels"
                    :value="weekCount"
                    color="white"
                    line-width="2"
                    padding="16"
                  ></v-sparkline>
                </v-sheet>

                <v-card-text class="mt-n3 pt-0 pb-1">
                  <v-list-item class="px-0">
                    <v-list-item-content
                      class="subheading font-weight-normal grey--text"
                      >{{ $t("Top.week_deliver_count") }}
                    </v-list-item-content>
                    <v-list-item-content
                      class="
                        d-flex
                        justify-end
                        px-0
                        py-1
                        title
                        font-weight-bols
                        mb-2
                      "
                    >
                      {{ ordersWeekTotal.total_count }}
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card class="mt-6">
                <v-sheet
                  class="v-sheet--offset mx-auto"
                  color="orange"
                  elevation="3"
                  max-width="calc(100% - 32px)"
                >
                  <v-sparkline
                    :labels="labels"
                    :value="ordersTotalByHourValue"
                    color="white"
                    line-width="2"
                    padding="16"
                  ></v-sparkline>
                </v-sheet>

                <v-card-text class="mt-n3 pt-0 pb-1">
                  <v-list-item class="px-0">
                    <v-list-item-content
                      class="subheading font-weight-normal grey--text"
                      >{{ $t("Top.orders_wait_deliver_price") }}
                    </v-list-item-content>
                    <v-list-item-content
                      class="
                        d-flex
                        justify-end
                        px-0
                        py-1
                        title
                        font-weight-bols
                        mb-2
                      "
                      >{{ $t("Global.money") }}
                      {{ ordersTotal.total_price }}
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
              </v-card>
              <div class="hide">1</div>
              <!-- 周 -->
              <v-card class="mt-6">
                <v-sheet
                  class="v-sheet--offset mx-auto"
                  color="deep-orange"
                  elevation="3"
                  max-width="calc(100% - 32px)"
                >
                  <v-sparkline
                    :labels="week_labels"
                    :value="weekPrice"
                    color="white"
                    line-width="2"
                    padding="16"
                  ></v-sparkline>
                </v-sheet>

                <v-card-text class="mt-n3 pt-0 pb-1">
                  <v-list-item class="px-0">
                    <v-list-item-content
                      class="subheading font-weight-normal grey--text"
                      >{{ $t("Top.week_deliver_price") }}
                    </v-list-item-content>
                    <v-list-item-content
                      class="
                        d-flex
                        justify-end
                        px-0
                        py-1
                        title
                        font-weight-bols
                        mb-2
                      "
                      >{{ $t("Global.money") }}
                      {{ ordersWeekTotal.total_price }}
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <!-- 待办事项 -->
        <v-col cols="12" md="4">
          <ToDos class="mb-6" :todos="todos" :returnTodos="returnTodos" />
        </v-col>

        <!-- 月 -->
        <v-col cols="12" sm="6" md="8">
          <v-card class="mt-6">
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="teal"
              elevation="3"
              max-width="calc(100% - 32px)"
            >
              <v-sparkline
                :labels="month_labels"
                :labelSize="
                  month_labels.length >= 50
                    ? 1
                    : month_labels.length >= 20
                    ? 2
                    : 3
                "
                :value="monthCount"
                color="white"
                line-width="2"
                padding="16"
              ></v-sparkline>
            </v-sheet>

            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-list-item class="px-0">
                <v-list-item-content
                  class="subheading font-weight-normal grey--text"
                  >{{ $t("Top.month_deliver_count") }}
                </v-list-item-content>
                <v-list-item-content
                  class="
                    d-flex
                    justify-end
                    px-0
                    py-1
                    title
                    font-weight-bols
                    mb-2
                  "
                >
                  {{ ordersMonthTotal.total_count }}
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" md="8">
          <v-card class="mt-6">
            <v-sheet
              class="v-sheet--offset mx-auto"
              color="amber"
              elevation="3"
              max-width="calc(100% - 32px)"
            >
              <v-sparkline
                :labels="month_labels"
                :labelSize="
                  month_labels.length >= 50
                    ? 1
                    : month_labels.length >= 20
                    ? 2
                    : 3
                "
                :value="monthPrice"
                color="white"
                line-width="2"
                padding="16"
              ></v-sparkline>
            </v-sheet>

            <v-card-text class="mt-n3 pt-0 pb-1">
              <v-list-item class="px-0">
                <v-list-item-content
                  class="subheading font-weight-normal grey--text"
                  >{{ $t("Top.month_deliver_price") }}
                </v-list-item-content>
                <v-list-item-content
                  class="
                    d-flex
                    justify-end
                    px-0
                    py-1
                    title
                    font-weight-bols
                    mb-2
                  "
                  >{{ $t("Global.money") }}
                  {{ ordersMonthTotal.total_price }}
                </v-list-item-content>
              </v-list-item>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
var intervalRef = void 0;
var notifyDisplayed = 0;

import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import Top from "@/api/top";
import ToDos from "./ToDos";

export default {
  name: "Home",

  components: {
    Breadcrumbs,
    ToDos,
  },

  data: () => ({
    ordersByHour: null,
    ordersTotal: {},
    ordersWeekTotal: {},
    ordersMonthTotal: {},
    todos: {},
    returnTodos: {},

    labels: [
      "0:00",
      "3:00",
      "6:00",
      "9:00",
      "12:00",
      "15:00",
      "18:00",
      "21:00",
    ],
    week_labels: ["周一", "周二", "周三", "周四", "周五", "周六", "周日"],
    purchaseByWeek: null,
    purchaseByMonth: null,
  }),

  computed: {
    Year() {
      return new Date().getFullYear();
    },
    Month() {
      return new Date().getMonth() + 1;
    },
    month_labels() {
      var month_labels = [
        this.Year + "-" + this.Month + "-1",
        // "2",
        // "3",
        // "4",
        // "5",
        this.Year + "-" + this.Month + "-6",
        // "7",
        // "8",
        // "9",
        // "10",
        this.Year + "-" + this.Month + "-11",
        // "12",
        // "13",
        // "14",
        // "15",
        this.Year + "-" + this.Month + "-6",
        // "17",
        // "18",
        // "19",
        // "20",
        this.Year + "-" + this.Month + "-21",
        // "22",
        // "23",
        // "24",
        // "25",
        this.Year + "-" + this.Month + "-26",
        // "27",
        // "28",
        // "29",
        // "30",
        this.Year + "-" + this.Month + "-31",
      ];
      return month_labels;
    },

    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: true,
        href: "/home",
      },
    ],
    ordersCountByHourValue() {
      return this.cutHoursData(this.ordersByHour, "total_count", 3);
    },
    ordersTotalByHourValue() {
      return this.cutHoursData(this.ordersByHour, "total_price", 3);
    },

    weekCount() {
      return this.cutWeek(this.purchaseByWeek, "total_count", 1);
    },
    weekPrice() {
      return this.cutWeek(this.purchaseByWeek, "total_price", 1);
    },

    monthCount() {
      return this.monthWeek(this.purchaseByMonth, "total_count", 5);
    },
    monthPrice() {
      return this.monthWeek(this.purchaseByMonth, "total_price", 5);
    },
  },

  mounted() {
    this.refresh();
    this.refreshTodos();

    intervalRef = setInterval(() => {
      if (!notifyDisplayed) {
        this.refresh();
      }
    }, 5000);
  },

  methods: {
    refresh() {
      this.refreshOrders();
    },

    refreshOrders() {
      Top.day().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.ordersTotal = response.data.orders_total;
            this.ordersByHour = response.data.purchase_by_hour;
          }
        }.bind(this)
      );
      Top.week().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.ordersWeekTotal = response.data.orders_total;
            this.purchaseByWeek = response.data.purchase_by_week;
          }
        }.bind(this)
      );
      Top.month().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.ordersMonthTotal = response.data.orders_total;

            this.purchaseByMonth = response.data.purchase_by_week;
          }
        }.bind(this)
      );
    },

    refreshTodos() {
      Top.todos().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.todos = response.data;
          }
        }.bind(this)
      );

      Top.returnTodos().then(
        function (response) {
          if (response.data.status.isOK()) {
            this.returnTodos = response.data;
          }
        }.bind(this)
      );
    },

    cutHoursData(data, tag, hours) {
      if (!data) return [0, 0, 0, 0, 0, 0, 0, 0];
      var cutted = [];
      var i = 0;
      var c = 0;
      Object.values(data).forEach((d) => {
        if (i >= hours) {
          cutted.push(c);
          i = 0;
          c = 0;
        }
        c += Number(d[tag]);
        i++;
      });
      cutted.push(c);
      return cutted;
    },
    cutWeek(data, tag, day) {
      if (!data) return [0, 0, 0, 0, 0, 0, 0];
      var cutted = [];
      var i = 0;
      var c = 0;
      Object.values(data).forEach((d) => {
        if (i >= day) {
          cutted.push(c);
          i = 0;
          c = 0;
        }
        c += Number(d[tag]);
        i++;
      });
      cutted.push(c);
      return cutted;
    },
    monthWeek(data, tag, month) {
      if (!data)
        return [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0, 0, 0, 0,
        ];
      var cutted = [];
      var i = 0;
      var c = 0;
      Object.values(data).forEach((d) => {
        if (i >= month) {
          cutted.push(c);
          i = 0;
          c = 0;
        }
        c += Number(d[tag]);
        i++;
      });
      cutted.push(c);
      return cutted;
    },
  },
  beforeDestroy() {
    clearInterval(intervalRef);
    intervalRef = void 0;
  },
};
</script>

<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
.hide {
  opacity: 0;
}
</style>
